import React, { useEffect, useState, useRef } from "react";
import "./Verification.css";
import verificationImg from "../../assets/fing.jpeg";
import { useNavigate } from "react-router-dom";

const Verification = () => {
  const navigate = useNavigate();
  const timeoutRef = useRef(null);
  const hasCalledRef = useRef(false);
  const [scanMessage, setScanMessage] = useState(
    "⏳ Place your finger on the scanner..."
  );
  const [processing, setProcessing] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!hasCalledRef.current) {
      hasCalledRef.current = true;
      captureFingerprint();
    }

    // Cleanup timeout on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const captureFingerprint = async () => {
    const controller = new AbortController();
    timeoutRef.current = setTimeout(() => controller.abort(), 10000);

    try {
      /* 1️⃣ CAPTURE FINGERPRINT */
      setScanMessage("⏳ Place your finger on the scanner...");
      const captureRes = await fetch(
        "http://localhost:8030/morfinauth/capture",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Quality: "60", TimeOut: "10" }),
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutRef.current);

      if (!captureRes.ok) {
        throw new Error("FETCH_FAILED");
      }

      const captureData = await captureRes.json();

      if (captureData.ErrorCode !== "0") {
        throw new Error("CAPTURE_FAILED");
      }

      /* 2️⃣ GET TEMPLATE */
      setScanMessage("🔄 Extracting fingerprint template...");
      const templateRes = await fetch(
        "http://localhost:8030/morfinauth/gettemplate",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ TmpFormat: 2 }),
        }
      );

      const templateData = await templateRes.json();

      if (templateData.ErrorCode !== "0" || !templateData.ImgData) {
        throw new Error("TEMPLATE_FAILED");
      }

      const capturedTemplate = templateData.ImgData;

      /* 3️⃣ GET ALL FINGERPRINTS FROM DB */
      setScanMessage("🔍 Matching fingerprint...");
      const fingerprintsRes = await fetch(
        "https://mondelezbc.vsmglobaltechnologies.com/api/user/fingerprints"
      );

      if (!fingerprintsRes.ok) {
        throw new Error("DB_FETCH_FAILED");
      }

      const fingerprintsJson = await fingerprintsRes.json();
      const fingerprints = fingerprintsJson.data;

      /* 4️⃣ VERIFY AGAINST EACH FINGERPRINT */
      let matchFound = false;
      let matchedEmployeeCode = null;

      for (const fp of fingerprints) {
        // Skip if no fingerprint stored
        if (!fp.fingerprint_ansi) continue;

        const verifyRes = await fetch(
          "http://localhost:8030/morfinauth/verify",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              ProbTemplate: fp.fingerprint_ansi,
              GalleryTemplate: capturedTemplate,
              TmpFormat: 2,
            }),
          }
        );

        const verifyData = await verifyRes.json();

        if (verifyData.ErrorCode === "0" && verifyData.Status === true) {
          matchFound = true;
          matchedEmployeeCode = fp.employeeCode;
          console.log("✅ Match found:", matchedEmployeeCode);
          break;
        }
      }

      setProcessing(false);

      if (matchFound) {
        // Success - move to next page with employee code
        console.log("Matched Employee Code:", matchedEmployeeCode);
        navigate("/profile", { state: { employeeCode: matchedEmployeeCode } });
      } else {
        throw new Error("NO_MATCH");
      }
    } catch (err) {
      clearTimeout(timeoutRef.current);
      setProcessing(false);

      let errorTitle = "Fingerprint Error";
      let errorMessage =
        "An unexpected error occurred during fingerprint verification.";

      if (err.name === "AbortError") {
        errorTitle = "Scan Timeout";
        errorMessage =
          "The fingerprint scan timed out after 10 seconds. Please ensure your finger is properly placed on the scanner and try again.";
      } else if (err.message === "CAPTURE_FAILED") {
        errorTitle = "Capture Failed";
        errorMessage =
          "Failed to capture fingerprint. Please ensure the scanner is connected and your finger is clean and dry.";
      } else if (err.message === "TEMPLATE_FAILED") {
        errorTitle = "Template Extraction Failed";
        errorMessage =
          "Failed to extract fingerprint template. Please try scanning again with better finger placement.";
      } else if (err.message === "DB_FETCH_FAILED") {
        errorTitle = "Database Error";
        errorMessage =
          "Failed to fetch fingerprints from database. Please check your connection and try again.";
      } else if (err.message === "NO_MATCH") {
        errorTitle = "No Match Found";
        errorMessage =
          "Your fingerprint does not match any registered employee. Please contact your administrator.";
      } else if (
        err.message === "FETCH_FAILED" ||
        err.message.includes("fetch")
      ) {
        errorTitle = "Connection Error";
        errorMessage =
          "Unable to connect to the fingerprint scanner. Please ensure the device is connected and the service is running.";
      }

      showError(errorTitle, errorMessage);
    }
  };

  const showError = (title, message) => {
    setError({ title, message });
    setProcessing(false);

    // Redirect to home after 5 seconds
    setTimeout(() => {
      navigate("/");
    }, 5000);
  };

  return (
    <div className="verification-container">
      <a className="home-icon" href="/">
        <svg
          fill="#fff"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width="35px"
          height="35px"
          viewBox="0 0 495.398 495.398"
        >
          <g>
            <g>
              <g>
                <path
                  d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                />
                <path
                  d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                />
              </g>
            </g>
          </g>
        </svg>
      </a>
      <div className="verification-content">
        {!error ? (
          <>
            <p className="verification-text">
              Please verify your fingerprint
              <span className="telugu-text">
                దయచేసి మీ వేలిముద్రను ధృవీకరించండి
              </span>
            </p>

            <div className="scanner-container">
              <img
                src={verificationImg}
                alt="Fingerprint"
                className="fingerprint-icon"
              />
              {processing && <div className="scan-indicator scanning"></div>}
            </div>

            <p className="scan-message">{scanMessage}</p>
            <p className="timeout-note">⏱ Auto-cancel after 10 seconds</p>
          </>
        ) : (
          <div className="error-display">
            <span className="error-icon">⚠️</span>
            <h2 className="error-title">{error.title}</h2>
            <p className="error-message">{error.message}</p>
            <p className="redirect-note">Redirecting to home in 5 seconds...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Verification;
